import React from 'react';
import { usePlanningBottomupState } from '../Context/index';

export function Vat() {
  const { planningBottomup, checkVisibleBottomUp } = usePlanningBottomupState();
  const { planningBottomProducts } = planningBottomup;
  const vatField = [
    // {
    //   keyName: "vat",
    //   name: "VAT",
    // },
  ];
  if (vatField.length === 0) {
    return null;
  }
  return (
    checkVisibleBottomUp('vat') && (
      <table className="table custom-table layout-fixed planning-actual-tbl font-13 mr-3">
        <thead>
          <tr>
            {vatField?.map((vatItem, i) => {
              return (
                <th key={i} className="w-200px">
                  <span>{vatItem.name}</span>
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {(planningBottomProducts ?? [])?.map((trItem, iParent) => {
            return (
              <tr key={iParent}>
                {vatField?.map((tdItem, iTD) => {
                  return (
                    <td key={iTD} className="text-center">
                      {trItem[tdItem?.keyName] || 1}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    )
  );
}
export default Vat;
